import { CollectionItem, UserGetInfoCollections, UserGetInfoModel } from '@aipb/personal-content/shared/model';
import { sortCollectionsAsc } from '@aipb/personal-content/shared/util';
import { selectLoading, updateLoading, withLoading } from '@aipb/util/state';
import { Injectable } from '@angular/core';
import { createStore, select, withProps } from '@ngneat/elf';

interface FavoriteUserProps {
  favoriteId: string;
  trashbinId: string;
  collections?: UserGetInfoCollections;
  ui: {
    collections: {
      [key: string]: boolean;
    };
  };
}

const store = createStore(
  { name: 'personal-content-favorite-user' },
  withProps<FavoriteUserProps>({
    // @ts-expect-error foo
    favoriteId: null,
    // @ts-expect-error foo
    trashbinId: null,
    collections: {
      general: [],
      favorites: [],
      didactic: [],
      trashbin: []
    },
    ui: {
      collections: {}
    }
  }),
  withLoading()
);

@Injectable({
  providedIn: 'root'
})
export class FavoriteUserRepository {
  loading$ = store.pipe(selectLoading());
  // @ts-expect-error foo
  favoriteCollections$ = store.pipe(select((s) => s.collections.favorites));
  // @ts-expect-error foo
  generalCollections$ = store.pipe(select((s) => s.collections.general));
  // @ts-expect-error foo
  didacticCollections$ = store.pipe(select((s) => s.collections.didactic));
  // @ts-expect-error foo
  trashbinCollections$ = store.pipe(select((s) => s.collections.trashbin));
  favoriteCollectionId$ = store.pipe(select((state) => state.favoriteId));
  trashbinCollectionId$ = store.pipe(select((state) => state.trashbinId));

  get favoriteCollections(): CollectionItem[] {
    // @ts-expect-error foo
    return store.getValue().collections.favorites;
  }

  get generalCollections(): CollectionItem[] {
    // @ts-expect-error foo
    return store.getValue().collections.general;
  }

  get didacticCollections(): CollectionItem[] {
    // @ts-expect-error foo
    return store.getValue().collections.didactic;
  }

  get trashbinCollections(): CollectionItem[] {
    // @ts-expect-error foo
    return store.getValue().collections.trashbin;
  }

  get favoriteId(): string {
    return store.getValue().favoriteId;
  }

  get trashbinId(): string {
    return store.getValue().trashbinId;
  }

  init(data: UserGetInfoModel) {
    let allCollections = [...data.user.collections.favorites];
    const favoriteCollectionId = data.user.collections.favorites[0].id;
    const trashbinCollectionId = data.user.collections.trashbin[0].id;

    if (data.user.collections.general) {
      allCollections = [...allCollections, ...data.user.collections.general];
    }

    if (data.user.collections.didactic) {
      allCollections = [...allCollections, ...data.user.collections.didactic];
    }

    const UI: { [key: string]: boolean } = {};

    for (const collection of allCollections) {
      UI[collection.id] = false;
    }

    UI[favoriteCollectionId] = true;

    store.update((state) => ({
      ...state,
      collections: {
        favorites: sortCollectionsAsc(data.user.collections.favorites || []),
        general: sortCollectionsAsc(data.user.collections.general || []),
        didactic: sortCollectionsAsc(data.user.collections.didactic || []),
        trashbin: sortCollectionsAsc(data.user.collections.trashbin || [])
      },
      favoriteId: data.user.collections.favorites[0].id,
      trashbinId: data.user.collections.trashbin[0].id,
      ui: {
        ...state.ui,
        collections: {
          ...UI,
          ...state.ui.collections
        }
      }
    }));
  }

  setLoading(loading: boolean) {
    store.update(updateLoading(loading));
  }

  toggleCollection(id: string): void {
    store.update((state) => ({
      ...state,
      ui: {
        ...state.ui,
        collections: {
          ...state.ui.collections,
          [id]: !state.ui.collections[id]
        }
      }
    }));
  }

  closeAllCollections(): void {
    store.update((state) => {
      const collections = state.ui.collections;

      for (const key of Object.keys(state.ui.collections)) {
        collections[key] = false;
      }

      return {
        ...state,
        ui: {
          ...state.ui,
          collections
        }
      };
    });
  }

  isCollectionVisible(id: string): boolean {
    return store.getValue().ui.collections[id];
  }

  reset() {
    store.reset();
  }
}
